import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import { updateLeadFields } from 'bundles/project/actions/leads';
import {
  ACCESS_LEVELS,
  SELECTABLE_ACCESS_LEVELS,
  PUBLIC_ACCESS_OPTION,
  REVOKE_OPTION,
  publicAccessDisplay
} from '../../../helper/lead_access_levels';
import { saveErrorText } from '../../../helper/save_error_text';

// TODO: Probably these values should come from the BE, see how getPossibleLeadStatuses is implemented

function findCurrentSelection(value) {
  return ACCESS_LEVELS.find(element => element.value == value) || null;
}

function prepareSelectableOptions(currentSelection) {
  if (currentSelection === PUBLIC_ACCESS_OPTION) {
    return SELECTABLE_ACCESS_LEVELS;
  } else {
    // Removing the current selection from the options
    return [...SELECTABLE_ACCESS_LEVELS, REVOKE_OPTION].filter(element => element.value != currentSelection);
  }
}

function DocAccessLevelSelect({
  ariaLabel, columnName, lead, selectComponent: SelectComponent = Select, onSaveMessage, onUpdate
}) {
  // The column name refers to the current lead attribute. It could be docAccessLevelForLease or docAccessLevelForSale
  const accessLevel = findCurrentSelection(lead[columnName]);
  const selectableLevels = prepareSelectableOptions(lead[columnName]);

  const handleAccessUpdate = async (option) => {
    const newAccessLevel = option.value;
    try {
      await onUpdate(lead, { [columnName]: newAccessLevel });
      onSaveMessage?.({ type: 'success', text: 'Successfully saved' });
    } catch (errors) {
      onSaveMessage?.({ type: 'error', text: saveErrorText(errors) });
    }
  };

  return (
    <React.Fragment>
      <SelectComponent
        aria-label={ariaLabel}
        isSearchable={false}
        menuPortalTarget={document.body} // This allows to display the select options above the table
        options={selectableLevels}
        placeholder={publicAccessDisplay}
        value={accessLevel}
        onChange={handleAccessUpdate}
      />
    </React.Fragment>
  );
}

const mapDispatchToProps = {
  onUpdate: updateLeadFields
};

DocAccessLevelSelect.propTypes = {
  ariaLabel: PropTypes.string,
  columnName: PropTypes.string,
  lead: PropTypes.object,
  selectComponent: PropTypes.elementType,
  onSaveMessage: PropTypes.func,
  onUpdate: PropTypes.func
};

export default connect(null, mapDispatchToProps)(DocAccessLevelSelect);
